import { ExperienceSource } from 'model/IExperience';
import { getPricePerPerson } from 'utils/getPrettyPrice';

import CurrencyHelper from './CurrencyHelper';

export const getExperienceAdvertisedPricePerPerson = (
  experience: ExperienceSource,
  currency: string,
  options: { roundPrice?: boolean } = {},
): string => {
  const roundPrice = options.roundPrice ?? false;
  const advertisedCentValue =
    experience?.pricing?.advertised_price_origin?.amount?.centValue ?? 0;
  const advertisedPrice = advertisedCentValue / 100;

  return CurrencyHelper.getPrettyPrice(advertisedPrice, currency, roundPrice);
};

export const getExperiencePricePerPerson = (
  experience: ExperienceSource,
  nrOfAdults: number,
  nrOfChildren: number,
  currency: string,
  options: { roundPrice?: boolean } = {},
) => {
  const roundPrice = options.roundPrice ?? false;

  const perPersonPrice = getPricePerPerson(
    experience,
    nrOfAdults,
    nrOfChildren,
  );

  return CurrencyHelper.getPrettyPrice(perPersonPrice, currency, roundPrice);
};
